










































































































































import { Component, Ref } from "vue-property-decorator";
import ReceiptEditAddCareBase from "./ReceiptEditAddCareBase";
import VisitMessage from "./common/VisitMessage.vue";
import VisitTitle from "./common/VisitTitle.vue";
import VisitInfoV2 from "./care/VisitInfoV2.vue";
import VisitContentDiv from "./care/VisitContentDiv.vue";
import StaffDiv from "./care/StaffDiv.vue";
import SenmonCareDiv from "./care/SenmonCareDiv.vue";
import TimeDiv from "./care/TimeDiv.vue";
import OneMonthAddV3 from "./care/OneMonthAddV3.vue";
import EveryTimeV3 from "./care/EveryTimeV3.vue";
import FirstFlgV2 from "./care/FirstFlgV2.vue";
import OtherV3 from "./care/OtherV3.vue";
import ReceiptEditAddBase from "./ReceiptEditAddBase";
import PractitionerDiv from "./care/PractitionerDiv.vue";

@Component({
  components: {
    VisitMessage,
    VisitTitle,
    VisitInfoV2,
    VisitContentDiv,
    StaffDiv,
    SenmonCareDiv,
    TimeDiv,
    OneMonthAddV3,
    EveryTimeV3,
    FirstFlgV2,
    OtherV3,
    PractitionerDiv
  }
})
export default class ReceiptEditAddCareV4 extends ReceiptEditAddCareBase
  implements ReceiptEditAddBase {
  @Ref("oneMonthAddV3") private readonly oneMonthAddV3!: OneMonthAddV3;
  @Ref("everyTimeV3") private readonly everyTimeV3!: EveryTimeV3;
  @Ref("firstFlgV2") private readonly firstFlgV2!: FirstFlgV2;
  @Ref("otherV3") private readonly otherV3!: OtherV3;

  //-----------------------------------------------------
  // ボタン群
  //-----------------------------------------------------
  //登録
  async registration(onSuccess?: Function) {
    if (!this.patientHeader.validate()) {
      await this.$openAlert("入力内容に不備があります");
      return;
    }

    //請求履歴確定済
    if (this.isBilledCare == 1) {
      await this.$openAlert(
        "請求履歴が確定されています。管理者へ請求履歴を未確定にするように連絡してください"
      );
      return;
    }

    //サービス訪問（自費）チェック時
    if (this.service_visit) {
      if (
        !(await this.$openConfirm(
          "請求対象外となるため画面から消えますが宜しいですか？"
        ))
      ) {
        return;
      }
    }

    //登録対象が在宅がんで同じ期間に介護訪問がある場合
    if (this.homeCancerCareFlg) {
      if (
        !(await this.$openConfirm(
          "在宅がん医療総合診療料の期間に介護保険の実績が含まれています" +
            this.homeCancerCareDay +
            "日。本当に登録しますか？（ケアマネジャーへご確認ください。）"
        ))
      ) {
        return;
      }
      //登録対象が在宅がんの場合
    } else if (this.event.home_cancer_flg == 1) {
      if (
        !(await this.$openConfirm(
          "在宅がん医療総合診療料期間の実績は請求対象外となるため保険請求には反映されませんが宜しいですか？"
        ))
      ) {
        return;
      }
    }
    //情報提供療養費を加算しようとするが情報提供先が選択されていない
    if (
      this.receiptVisitRecord.mouth_renkei_kyoka_flg &&
      !this.hasInfoProviderMouthRenkei
    ) {
      if (
        !(await this.$openConfirm(
          "口腔連携強化加算を算定していますが、情報提供先（歯科医療機関）または 情報提供先（居宅介護支援事業所）を設定していません。\n情報提供先（歯科医療機関）または 情報提供先（居宅介護支援事業所）を設定する手順は、「月1回加算」の右にある（？）マーク で確認できます。"
        ))
      ) {
        return;
      }
    }

    //clearDisableItem（disableの項目は0で保存しに行く）
    this.oneMonthAddV3.clearDisableItemV3();
    this.everyTimeV3.clearDisableItemV3();
    this.firstFlgV2.clearDisableItem();
    this.otherV3.clearDisableItemV3();

    //バックエンド側で登録時チェックする
    this.postJsonCheck(
      window.base_url + "/api/patient/receipt/registration",
      {
        patient_id: this.patientId,
        service_visit: this.service_visit,
        yearmonth: this.yearmonth,
        event: this.event,
        events: this.events,
        receipt_visit_record: this.receiptVisitRecord,
        visit_content_div: this.visit_content_div
      },
      async res => {
        this.registrationMessage = res.data.registration_message;
        this.message("登録しました");
        this.update();
        onSuccess?.();
      },
      err => {
        if (err.response?.data.registration_message) {
          this.registrationMessage = err.response?.data.registration_message;
        }
      }
    );
  }

  //実績解除
  async releaseResult() {
    //請求履歴確定済
    if (this.isBilledCare == 1) {
      await this.$openAlert(
        "請求履歴が確定されています。管理者へ請求履歴を未確定にするように連絡してください"
      );
      return;
    }

    //確認
    if (!(await this.$openConfirm("実績解除します。よろしいですか？"))) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/patient/receipt/releaseResult",
      {
        patient_id: this.patientId,
        receipt_visit_record: this.receiptVisitRecord,
        yearmonth: this.yearmonth,
        office_id: this.officeHistory.office_id
      },
      () => {
        this.message("登録実績を解除しました");
        this.update();
      }
    );
  }

  //リセット
  async reset() {
    //請求履歴確定済
    if (this.isBilledCare == 1) {
      await this.$openAlert(
        "請求履歴が確定されています。管理者へ請求履歴を未確定にするように連絡してください"
      );
      return;
    }

    //確認
    if (
      !(await this.$openConfirm(
        "記録書IIを再提出します。加算情報等、初期化されますが宜しいですか？"
      ))
    ) {
      return;
    }

    //医療保険に変更（介護訪問なのに介護保険がないもしくは、指示書が医療扱い）
    if (this.judgeMed()) {
      //リセットメッセージ
      const resetColumns = this.resetColumns();

      if (resetColumns != "") {
        if (
          !(await this.$openConfirm(
            "適用保険が医療保険に変更されているため、" +
              resetColumns +
              "の選択が解除されますがよろしいですか？"
          ))
        ) {
          return;
        }
      }
    }

    this.postJsonCheck(
      window.base_url + "/api/patient/receipt/reset",
      {
        patient_id: this.patientId,
        yearmonth: this.yearmonth,
        event: this.event
      },
      async res => {
        this.resetMessage = res.data.reset_message;
        this.message("リセットしました");
        this.update();
      },
      err => {
        if (err.response?.data.reset_message) {
          this.resetMessage = err.response?.data.reset_message;
        }
      }
    );
  }
}
